<script>
// 从指定的url地址获取图像尺寸信息
import {areaList} from "@vant/area-data";
import {debounce} from "@/util/tools";

function getImageSizeByUrl(url) {
  return new Promise((resolve, reject) => {
    let image = new Image();
    image.onload = function () {
      resolve({
        width: image.width,
        height: image.height
      });
    };
    image.onerror = function () {
      reject(new Error('Failed to load image'));
    };
    image.src = url;
  })
}

export default {
  name: "decennial_choose_course",
  computed: {
    areaList() {
      return areaList
    }
  },
  data() {
    return {
      bannerImage: require("../assets/imgs/3000x1500.jpg"),
      maxCheckCount: 0,
      checkedList: [],
      checkedCourseCount: 0,
      pageHeight: 0,
      tabbarHeight: 0,
      allTeacherPanelStatus: false,
      allCheckedCourseStatus: false,
      confirmStatus: false,
      teachers: [],
      user_id: null,
      addressInfoNote: "",
      errorMessage: "暂无可领取的课程",
      debounceOnConfirm: debounce(this.onConfirm, 200, false),
      isLoading: false
    }
  },
  watch: {
    teachers: {
      handler(newVal) {
        let totalCount = [];
        let totalCourseCount = 0;
        for (let teacher of this.teachers) {
          let checked_course_list = teacher.courses.filter(course => course.checked);
          if (checked_course_list.length > 0) {
            for (let course of checked_course_list) {
              course.teacher_name = teacher.name;
            }
            totalCourseCount += checked_course_list.length;
            totalCount.push(...checked_course_list);
          }
        }
        this.checkedList = totalCount;
        this.checkedCourseCount = totalCourseCount;
      },
      deep: true
    }
  },
  mounted() {
    this.initData();
    this.init();
  },
  methods: {
    initData() {
      this.user_id = this.$ls.get("user_id");
      // this.user_id = "37839646997";
      // this.user_id = 6040939 * 6247;
      this.$axios.get("/item/getReceiveList", {
        params: {item_user_id: this.user_id}
      }).then(res => {
        if (res.other_data && res.other_data.receive_limit_num != undefined && res.other_data.received_num != undefined) {
          this.maxCheckCount = res.other_data.receive_limit_num - res.other_data.received_num;
        }
        if (res.code != 10001 && res.code != 10000) {
          if (res.msg) {
            this.errorMessage = res.msg;
          }
          this.$toast(this.errorMessage);
          return;
        }
        this.teachers = this.handleOriginList(res.data);
      }).catch(e => {
        console.log(e);
      })
    },
    handleOriginList(oarr) {
      let arr = [];
      let teachers_obj = {};
      for (let item of oarr) {
        item["checked"] = false;
        item["tip"] = item.tip || "";
        if (teachers_obj[item.desc]) {
          teachers_obj[item.desc].push(item);
        } else {
          teachers_obj[item.desc] = [item];
        }
      }
      for (let key in teachers_obj) {
        let teacher = {
          name: key,
          courses: teachers_obj[key],
          tip: teachers_obj[key][0]['tip']
        }
        arr.push(teacher);
      }

      console.log(arr);
      return arr;
    },
    // 滚动到指定元素位置
    scrollToElement(element) {
      element.scrollIntoView({behavior: "smooth", block: "center"});
      this.$nextTick(() => {
        const ani = element.animate([
          {borderColor: '#EFEFF4'},
          {borderColor: '#EE0A24FF'},
          {borderColor: '#EFEFF4'},
          {borderColor: '#EE0A24FF'},
          {borderColor: '#EFEFF4'},
          {borderColor: '#EE0A24FF'},
        ], {
          duration: 1000,
          delay: 300
        })
        ani.finished.then(() => {
          element.style.borderBottomColor = "#EFEFF4";
        })
      })
    },
    async init() {
      let headerHeight = document.querySelector('.van-nav-bar').offsetHeight;
      let tabbarHeight = document.querySelector('.van-tabbar').offsetHeight;
      this.pageHeight = window.innerHeight - headerHeight - tabbarHeight;
      this.tabbarHeight = tabbarHeight;
    },
    onClickTeacher(teacher, index) {
      let element = this.$refs.teacherRefs[index];
      this.allTeacherPanelStatus = false;
      this.$nextTick(() => {
        this.scrollToElement(element);
      })
    },
    showCart() {
      if (this.checkedList.length <= 0) {
        return;
      }
      this.allCheckedCourseStatus = true;
    },
    async onConfirm() {
      // console.log(this.checkedList, this.checkedCourseCount);
      // console.log("onConfirm");
      this.allCheckedCourseStatus = false;
      if (this.checkedList.length <= 0) {
        this.$toast("请选择课程");
        return;
      }
      if (this.checkedList.length < this.maxCheckCount) {
        this.$toast("至少选择" + this.maxCheckCount + "门课程");
        return;
      }
      // this.confirmStatus = true;
      let historyAddress = await this.$axios.get("/item/getUserHistoryAddress", {
        params: {
          item_user_id: this.user_id
        }
      })
      let content = {};
      if (historyAddress.data) {
        content.county = historyAddress.data.area;
        content.province = historyAddress.data.province;
        content.city = historyAddress.data.city;
        content.addressDetail = historyAddress.data.address;
        content.name = historyAddress.data.name;
        content.tel = historyAddress.data.mobile;
      }
      this.onSave(content);
    },
    onSave(content) {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      let ids = [];
      this.checkedList.map(e => {
        ids.push(e.id);
      })
      this.$axios.post("/item/addFreeOrders", {
        item_user_id: this.user_id,
        item_ids: ids.join(","),
        name: content.name,
        mobile: content.tel,
        province: content.province,
        city: content.city,
        area: content.county,
        address: content.addressDetail,
        notes: this.addressInfoNote
      }).then(res => {
        if (res.code === 10001) {
          this.$toast.success("提交成功");
          this.checkedList.map(e => {
            e.checked = false;
          })
          this.checkedList = [];
          this.checkedCourseCount = 0;
          this.confirmStatus = false;
          this.teachers = [];
          this.initData();

          setTimeout(() => {
            this.$router.push("/user");
          }, 2000)
        } else {
          this.$toast.fail({
            message: res.msg,
          });
        }
      }).finally(() => {
        this.isLoading = false;
      })
    },
    onClose() {
      this.confirmStatus = false;
    },
    onRemoveCartCourse(course) {
      course.checked = false;
    }
  }
}
</script>

<template>
  <div class="page" :style="{'--tabbar-height': tabbarHeight + 'px'}">
    <div class="banner">
      <img :src="bannerImage" alt="">
    </div>
    <div class="scroll-view">
      <p class="tips" v-if="teachers && teachers.length > 0">您可以选择 <span>{{ maxCheckCount }}</span> 个课程</p>
      <div class="list" v-if="teachers && teachers.length > 0">
        <div class="item-content" v-for="(teacher, index) in teachers" :key="teacher.name" ref="teacherRefs">
          <div class="item">
            <!--            <h1>{{ teacher.name }} <span style="font-size: 13px;" class="text-red-500" v-if="teacher.tip">({{teacher.tip}})</span></h1>-->
            <h1>{{ teacher.name }}</h1>
            <!--            <p v-if="teacher.tip" class="text-red-500 mb-4" style="font-size: 13px;">{{teacher.tip}}</p>-->
            <div class="course_list">
              <div class="course_item flex flex-col" v-for="course in teacher.courses" :key="course.id">
                <van-checkbox v-model="course.checked" checked-color="#EE0A24FF"
                              :disabled="checkedCourseCount >= maxCheckCount && !course.checked">{{ course.name }}
                </van-checkbox>
                <p style="font-size: 13px; margin-top: 10px;" class="text-red-500" v-if="course.tip">
                  ({{ course.tip }})</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <p class="font-bold text-center py-10">{{ errorMessage }}</p>
      </div>
    </div>

    <div class="float-button" @click="allTeacherPanelStatus = true" v-if="teachers && teachers.length > 0">
      <p>查找</p>
      <p>老师</p>
    </div>

    <div class="cart-view flex justify-between items-center" @click="showCart" :class="{'full': allCheckedCourseStatus}"
         v-if="teachers && teachers.length > 0">
      <img src="@/assets/imgs/cart.png" alt="">
      <div class="cart-info flex-1">
        <p class="text-white">已选择: <span class="font-bold text-xl">{{ checkedCourseCount }}个</span></p>
      </div>
      <div class="cart-button h-full px-3 bg-yellow-400" @click.stop="debounceOnConfirm">
        <span>立即领取</span>
      </div>
    </div>

    <van-action-sheet v-model="allTeacherPanelStatus" :title="`查找老师 (${teachers.length})`">
      <div class="all-teacher-panel p-5">
        <div class="flex flex-wrap gap-5">
          <div v-for="(teacher, index) in teachers" :key="teacher.name" @click="onClickTeacher(teacher, index)">
            <p class="flex items-center justify-center rounded bg-gray-200 p-2">{{ teacher.name }}</p>
          </div>
        </div>
      </div>
    </van-action-sheet>

    <van-action-sheet class="cart-popup" v-model="allCheckedCourseStatus" :title="`已选课程 (${checkedCourseCount})`">
      <div class="all-checked-course-panel p-5">
        <div v-if="checkedList.length > 0">
          <div v-for="item in checkedList" :key="item.name"
               class="flex items-center justify-between mb-3 border-b pb-3">
            <div class="items-center flex-1 overflow-hidden">
              <p class="truncate">{{ item.name }} (<span class="font-bold">{{ item.teacher_name }}</span>)</p>
            </div>
            <!--            <van-icon size="20" name="cross" color="#999" @click="onRemoveCartCourse(item)" />-->
            <span class="text-red-500" @click="onRemoveCartCourse(item)">移除</span>
          </div>
        </div>
        <div v-else>
          <p class="text-center my-5 text-gray-500">暂无已选课程</p>
        </div>
      </div>
    </van-action-sheet>

    <van-dialog v-model="confirmStatus" title="确认订单" :show-cancel-button="false" :show-confirm-button="false"
                v-if="false">
      <div class="py-3">
        <van-address-edit
            :area-list="areaList"
            :area-columns-placeholder="['请选择', '请选择', '请选择']"
            save-button-text="提交订单"
            @delete="onClose"
            @save="onSave"
            style="padding-bottom: 0 !important;"
        >
          <div slot="default">
            <div class="flex items-center justify-between" style="padding: 10px 16px;">
              <span class="text-gray-500 text-sm" style="width: 4.1em;">备注</span>
              <van-field clearable class="flex-1" v-model="addressInfoNote" placeholder="备注"></van-field>
            </div>
          </div>
        </van-address-edit>
        <div class="px-3">
          <van-button block round type="default" @click="onClose">重新选择</van-button>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<style scoped>

.page {
  --left-margin: 20px;
  --bottom-margin: 20px;
  --tabbar-height: 0px;
  --cart-view-height: 50px;
  padding-bottom: calc(var(--tabbar-height) + var(--cart-view-height) + var(--bottom-margin) * 2) !important;
}

.banner img {
  width: 100%;
}

.scroll-view {
  /*
  position: relative;
  flex: 1;
  overflow-y: auto;
   */
}

.list {
  padding: 10px;
}

.scroll-view .tips {
  position: sticky;
  top: 0;
  background-color: #FFF;
  font-size: 18px;
  color: #555;
  text-align: center;
  margin-bottom: calc(var(--bottom-margin) / 2);
  border-bottom: 1px solid #EFEFF4;
  padding-bottom: calc(var(--bottom-margin) / 2);
  padding-top: calc(var(--bottom-margin) / 2);
  z-index: 10;
}

.scroll-view .tips span {
  font-weight: bold;
  color: #F00;
}

.item-content {
  border: 1px solid transparent;
  margin-bottom: calc(var(--bottom-margin) * 1.2);
  border-bottom-color: #EFEFF4;
  padding-bottom: calc(var(--bottom-margin) * 1.2);
}

.item {
  padding-left: var(--left-margin);
}

.item h1 {
  margin-bottom: var(--bottom-margin);
  font-weight: bold;
  font-size: 18px;
}

.course_list .course_item {
  display: flex;
  margin-left: var(--left-margin);
}

.course_list .course_item:not(:last-child) {
  margin-bottom: var(--bottom-margin);
}

.float-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  font-size: 16px;
  font-weight: bold;
  background-color: #EE0A24FF;
  color: #FFF;
  right: var(--left-margin);
  bottom: calc(var(--tabbar-height) + var(--bottom-margin) * 2 + var(--cart-view-height));
  z-index: 999;
  /*立体感*/
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.3);
}

.cart-view {
  --cart-image-width: 80px;
  position: fixed;
  bottom: calc(var(--tabbar-height) + var(--bottom-margin));
  left: var(--left-margin);
  right: var(--left-margin);
  background-color: #292929;
  border-radius: var(--tabbar-height);
  height: var(--cart-view-height);
  transition: bottom 0.5s;
}

.cart-view.full {
  z-index: 2501;
  bottom: var(--bottom-margin);
}

.cart-view > img {
  position: absolute;
  width: var(--cart-image-width);
  bottom: 2px;
  filter: drop-shadow(5px 5px 10px #292929);
}

.cart-view .cart-info {
  margin-left: calc(var(--cart-image-width) + var(--left-margin));
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.cart-view .cart-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-right-radius: var(--cart-view-height);
  border-bottom-right-radius: var(--cart-view-height);
  font-weight: bold;
}

.cart-popup {
  z-index: 2500 !important;
  padding-bottom: calc(var(--cart-view-height) + var(--bottom-margin) * 2);
}
</style>